// eslint-disable-next-line import/no-anonymous-default-export
export default {
    translation: {
        next_btn: "متابعة",
        logout: "تسجيل خروج",
        back_btn: "رجوع",

        errors: {
            invalid_password: "رمز مرور خاطئ. يجب أن يكون مكونًا من 6 إلى 20 حرفًا، ويحتوي على حرف كبير وحرف صغير ورقم.",
            hear_us_error: "يرجى تحديد المكان الذي سمعت عنا.",
            email_validation: "يجب أن يحتوي البريد الإلكتروني على الرمز \"@\".",
            required_field: "هذه الخانة مطلوبة",
            conf_email_error: "البريد الإلكتروني ورسالة التأكيد الإلكترونية غير متطابقين",
            conf_password_error: "كلمة المرور وتأكيد كلمة المرور غير متطابقين",
            canadian_email_error: "لا يمكننا قبول عناوين البريد الإلكتروني الكندية",
            enter_characters: "أدخل ما لا يزيد عن 11 حرفًا.",
            tax_enter_characters: "أدخل ما لا يزيد عن 10 حرفًا.",
            conf_ssn_error: "`SSN وتأكيد SSN غير متطابقين`",
            conf_tax_error: "`Tax ID وتأكيد Tax ID غير متطابقين`",
            years_old_error: "يجب أن يكون عمرك 18 عامًا على الأقل.",
            exp_date_error: "يجب أن يكون متأخرًا عن التاريخ الحالي.",
            exp_issue_date_error: "يجب أن يكون بعد تاريخ الإصدار.",
            select_country_error: "رجاء قم بإختيار دوله.",
            exp_earlier_date_error: "يجب أن يكون أقدم من التاريخ الحالي.",
            liquid_assets_error: "يجب أن تكون القيمة الصافية السائلة مساوية أو أقل من القيمة الصافية",
            low_assets_error: "اختيار الأصول السائلة منخفض جدًا بالنسبة لهذا الحساب",
            low_income_error: "اختيار الأصول السائلة منخفض جدًا بالنسبة لهذا الحساب",
            low_worth_error: "اختيار الدخل السنوي منخفض جدًا بالنسبة لهذا الحساب",
            invalid_signature: "يجب أن يتطابق توقيعك مع اسمك في التطبيق كـ",
            indicate_error: "يجب أن تزيد نسب الملكية إلى 100%",
            liquid_error: "إذا كان صافي ثروتك السائلة أقل من 20000 دولار، فلا يمكننا الموافقة على هامشك. الرجاء اختيار حساب نقدي.",
            valid_date: "الرجاء إدخال تاريخ صالح بتنسيق MM/DD/YYYY.",
            custodial_year: "يجب أن يكون عمرك أقل من 18 عامًا",
            main_user_ssn: "لا يمكن أن يكون هو نفسه رقم الضمان الاجتماعي (SSN) الخاص بالمستخدم الرئيسي",
            zip_code_format: "الرمز البريدي غير صالح. يجب أن يكون NNNNN أو NNNNN-NNNN",
            required_file_upload: "مطلوب تحميل الملف",
            or: "أو"
        },

        register: {
            user_registration: "فتح حساب \"تشويس تريد\" سهل!",
            for_limited: "يوجد حد أدنى قدره 100 دولار لفتح حساب على \"تشويس تريد\". إذا تقدمت بطلب للحصول على حساب هامش، فهناك حد أدنى قدره 2000 دولار.",
            username: "اسم المستخدم",
            email: "عنوان البريد الالكتروني",
            password: "كلمة المرور",
            confirm_password: "تأكيد كلمة المرور",
            hear_us: "أين سمعت عنا؟",
            citizen_status: "حالة الجنسية",
            type_account: "حدد نوع الحساب الذي ترغب في فتحه.",
            individual: "فردي",
            joint_account_type: "الحساب المشترك",
            custodial: "وصاية",
            ira: "حساب التقاعد الفردي",
            specialty_account_type: "حساب الخصوصية",
            already_sign_in: "هل بدأت بالفعل طلبك؟ تسجيل الدخول.",
            important_info: "لمساعدة الحكومة على مكافحة تمويل أنشطة الإرهاب وغسل الأموال، يتطلب القانون الفيدرالي من جميع المؤسسات المالية الحصول على المعلومات التي تحدد هوية كل شخص يفتح حسابًا والتحقق منها وتسجيلها. ماذا يعني ذلك بالنسبة لك: عندما تفتح حسابًا، سنطلب منك اسمك وعنوانك وتاريخ ميلادك وغيرها من المعلومات التي ستسمح لنا بالتعرف عليك. قد نطلب أيضًا رؤية رخصة القيادة الخاصة بك أو المستندات التعريفية الأخرى.",
            security_disclaimer: "منتجات وخدمات الأوراق المالية الأمريكية من خلال ChoiceTrade، وهي شركة وساطة خاضعة للتنظيم في الولايات المتحدة. لا توصي ChoiceTrade بأية استراتيجية استثمار أو أوراق مالية. الموقع الإلكتروني الذي أتيت منه إلى ChoiceTrade وChoiceTrade هما شركتان منفصلتان. لا تعكس المحتويات والمنشورات على الويب غير التابعة لـ ChoiceTrade آراء ChoiceTrade ولم تتم مراجعتها من قبل ChoiceTrade للتأكد من اكتمالها أو دقتها.",
            big_saving_text: "اكتشف كيف يمكنك الاستفادة من التوفير الكبير من خلال استكمال طلبك. وسوف يستغرق سوى بضع دقائق."
        },

        personal: {
            welcome: "أهلًا وسهلًا",
            welcome_pls: "يرجى متابعة طلبك أدناه.",
            personal_info: "المعلومات الشخصية",
            title: "اللقب",
            mr: "سيد",
            ms: "آنسة",
            mrs: "سيدة",
            dr: "طبيب",
            first_name: "الاسم الأول",
            last_name: "الاسم الأخير",
            date_of_birth: "تاريخ الولادة MM/DD/YYYY",
            ssn: "رقم التأمين الاجتماعي XXX-XX-XXXX",
            confirm_ssn: "قم بتأكيد رقم التأمين الاجتماعي (SSN) XXX-XX-XXXX",
            mobile_phone: "الهاتف المحمول (رمز الدولة ورقمها)",
            marital_status: "الحالة الإجتماعية",
            single: "أعزب",
            married: "متزوج",
            divorced: "مطلق",
            widow: "أرمل",
            iden_type: "نوع الهوية",
            state_dl: "رخصة قيادة الولاية",
            state_id: "بطاقة شخصية الهوية",
            national_id: "الهوية الوطنية",
            passport: "جواز السفر",
            iden_number: "رقم الهوية",
            issue_date: "تاريخ الإصدار MM/DD/YYYY",
            expiration_date: "تاريخ انتهاء الصلاحية MM/DD/YYYY",
            permanent_address: "العنوان الدائم",
            address2: "العنوان 2",
            city: "المدينة",
            select_country: "حدد الدولة",
            zip_code: "الرمز البريدي",
            select_state: "اختر حالة",
            different_address: "عنواني البريدي مختلف",
            mailing_address: "عنوان بريدي",
            mailing_address2: "عنوان بريدي 2",
            mailing_city: "المدينة",
            mailing_country: "حدد الدولة",
            mailing_zip_code: "الرمز البريدي",
            mailing_state: "اختر حالة",
            identification: "تعريف",
            street_number_name: "رقم الشارع واسم",
            issue_exp_date: "لا تحتوي هويتي على تاريخ إصدار أو انتهاء صلاحية",
            take_photo: "الآن يرجى تخصيص بعض الوقت لإرسال نسخة من بطاقة هويتك الصادرة عن الحكومة"
        },

        financial: {
            thanks: "شكرًا",
            need_financial_info: "الآن نحن بحاجة إلى معلوماتك المالية",
            financial_info: "معلومات مالية",
            employment_status: "حالة التوظيف",
            employed: "عامل",
            self_employed: "ذو مهنة حرة",
            retired: "متقاعد",
            homemaker: "رب منزل",
            student: "طالب",
            unemployed: "لا يعمل",
            school_name: "اسم المدرسة",
            occupation: "المهنة",
            accounting: "المحاسبة",
            agriculture: "الزراعة",
            banking_and_finance: "البنوك والتمويل",
            clerical: "العمل المكتبي",
            construction: "الإنشاءات",
            consulting: "الاستشارة",
            customer_service: "خدمة العملاء - مركز الاتصال",
            education: "التعليم",
            engineer: "الهندسة",
            government: "الحكومة",
            healthcare: "الرعاية الصحية",
            hotel_restaurant: "الفندقة والمطاعم",
            information: "تكنولوجيا المعلومات",
            internet: "الإنترنت والتجارة الإلكترونية",
            legal: "القانون",
            management_executive: "الإدارة والتنفيذية",
            manufacturing: "التصنيع",
            marketing: "التسويق",
            media: "الإعلام - الصحافة",
            non_profit: "غير ربحية",
            real_estate: "العقارات",
            retail: "التجزئة",
            sales: "المبيعات",
            science: "العلوم",
            security: "الضمان الاجتماعي / التقاعد",
            sports: "الرياضات",
            travel: "السفر والسياحة",
            wholesale: "الجملة",
            company_name: "اسم الشركة",
            business_address: "عنوان المؤسسة",
            city: "المدينة",
            select_country: "حدد الدولة",
            zip_code: "الرمز البريدي",
            select_state: "اختر حالة",
            source_of_income: "المصدر الأساسي للدخل",
            job: "المهنة",
            personal_saving: "مدخرات شخصية",
            spouse: "الزوج/ الوالدين",
            inheritance: "الميراث",
            investment: "الاستثمار",
            retirement_plan: "خطة التقاعد",
            real_estate_investment: "استثمار عقاري",
            stock_retirement: "رصيد المعاش التقاعدي",
            family_wealth: "ثروة الأسرة",
            passive_income: "الدخل السلبي",
            royalties: "العائدات",
            property_income: "دخل الممتلكات",
            portfolio_income: "دخل المحفظة",
            other: "أخرى",
            source_of_wealth: "المصدر الأساسي للثروة",
            personal_income_saving: "الدخل الشخصي/الادخار",
            sale_of_business: "الأعمال التجارية",
            annual_income: "الدخل السنوي",
            liquid_assets: "أصول سائلة",
            over: "زيادة",
            net_worth: "رأس المال",
            sold_business_name: "اسم النشاط التجاري المُباع",
            sale_amount: "مبلغ البيع",
            date_sold: "تاريخ البيع"
        },

        affiliation: {
            welcome: "أهلًا وسهلًا",
            affiliated: "بعد ذلك، نحتاج إلى معرفة ما إذا كنت تابعًا لأي مما يلي.",
            affiliation_information: "معلومات الانتساب",
            yes: "نعم",
            no: "لا",
            aff_company_name: "اسم الشركة",
            your_position: "موقعك",
            aff_person_name: "اسم شخص منتمي",
            agent_list: "يرجى إدراج وكيل لخدمة العملية",
            financial_regulator: "يرجى مسح نسخة من شهادة عضويتك ضوئيًا وإرسالها بالبريد الإلكتروني من الجهة التنظيمية المالية في بلدك إلى service@choicetrade.com.\"",
            political_organization: "يرجى تقديم أسماء ذلك المسؤول وأفراد أسرته المباشرين (بما في ذلك الأزواج السابقون)، بالإضافة إلى اسم المؤسسة السياسية الأجنبية ذات الصلة.",
            name: "اسم",
            organization: "المؤسسات",
            ownership_disclosure: "الإفصاح عن بيانات الملكية",
            ownership_disclosed: "وفقًا لقانون الأوراق المالية، القاعدة 14 ب -1 (ج). ما لم يعترض العميل، فنحن مطالبون بالإفصاح للمُصدر عن الاسم والعنوان والوضع الأمني لعملائنا الذين هم مالكون مستفيدون من الأوراق المالية لهذا المُصدر. إذا كنت لا تريد الكشف عن الملكية، يرجى تحديد هذا المربع.",
            privacy_and_policy: "لقد قرأت ووافقت على ChoiceTrade ",
            privacy_policy: "سياسة الخصوصية",
            are_member: "هل أنت أو أحد أفراد أسرتك مدير أو مساهم بنسبة 10٪ أو مسؤول في شركة مطروحة للتداول العام؟",
            NFA_or_CFTC: "هل أنت أو أحد أفراد أسرتك منتسب أو موظف لدى وسيط / مستشار استثماري لشركة تأمين تاجر / وسيط مسجل يمارس الأعمال التجارية في الولايات المتحدة أو أي بورصة أمريكية أو منظمة ذاتية التنظيم بما في ذلك SEC FINRA NFA أو CFTC؟",
            foreign_shell: "هل يتم تقديم هذا الطلب نيابة عن بنك وهمي أجنبي؟",
            owner_affiliated: "هل صاحب الحساب هذا تابع لبنك وهمي أجنبي؟",
            owner_offer: "هل يقدم صاحب الحساب خدمات إلى بنك وهمي أجنبي؟",
            bankruptcy_proceeding: "هل سبق لك أن تعرضت للإفلاس أو الحراسة القضائية أو أي إجراء آخر مشابه؟",
            commodity_account: "هل سبق لك أن خضعت للتحكيم في نزاع قانوني أو دعوى تعويض تتعلق بأوراق مالية أو حساب سلعة؟",
            commodity_firm: "هل سبق لك أن أغلقت أو تركت حسابًا خاملًا برصيد غير مدفوع في شركة أوراق مالية أو شركة سلع؟",
            business_with_you: "هل تلقيت أو ستتلقى أموالًا من أي شخص أو كيان ليس مالكًا لهذا الحساب والذي سيتم استخدامه لتمويل هذا الحساب خلال حياته؟ (إذا كنت تنوي تمويل الحساب بأموال شخص آخر في أي وقت ، فنحن نأسف لأننا لن نتمكن من التعامل معك.",
            financial_institution: "هل يتم تقديم هذا الطلب نيابة عن مؤسسة مالية أجنبية؟",
            close_associate: "هل يتم تقديم هذا الطلب نيابة عن شخصية سياسية عليا حالية أو سابقة (محددة أدناه) أو أحد أفراد الأسرة المباشرين أو زميل مقرب؟",
        },

        account: {
            welcome: "أهلًا وسهلًا",
            option_trading: "ضع في اعتبارك الآن الخيارات وإمكانيات التداول بالهامش التي تريدها لحسابك. يجب أن تتوافق تجربة تداول الخيارات مع مستوى تداول الخيارات الذي تريده. لن تتمكن من الوصول إلى مستويات أعلى من تداول الخيارات إذا لم تكن لديك خبرة.",
            account_privileges: "امتيازات الحساب",
            account_profile: "حدد الملف الشخصي للحساب",
            cash_margin: "كاش مارجن حساب",
            cash: "سيولة نقدية",
            day_trade1: "هل تنوي أن",
            day_trade2: "التداول اليومي",
            day_trade3: "التداول خلال اليوم",
            cash_margin_accounts: "تتمتع حسابات \"كاش مارجن\" بفوائد أكثر من الحسابات النقدية. لمزيد من المعلومات ، مرر مؤشر الماوس فوق كل ملف تعريف حساب.(يُسمح فقط بالحسابات النقدية لحسابات الحفظ)",
            specify_trading_level: "يرجى تحديد مستوى تداول الخيارات المطلوب لهذا الحساب. تتطلب معظم مستويات القدرة على تداول الخيارات هدفًا استثماريًا مضاربًا باستثناء المكالمات المغطاة. يرجى الإشارة إلى الدرجة المطلوبة من تداول الخيارات أدناه.",
            option_trading_level: "هدف الخيار المحدد ومستوى تداول الخيار المطلوب",
            choose_one: "اختر هدف",
            level1: "الهدف: الدخل: المستوى 1: بيع خيار الشراء المغطى",
            level2: "الهدف: المضاربة: المستوى 2: المستوى 1+ شراء خيار البيع والشراء",
            level3: "الهدف: المضاربة: المستوى 3: المستوى 2 + هوامش المدين",
            level4: "الهدف: المضاربة: المستوى 4: المستوى 3 + فروق العائد",
            level5: "الهدف: المضاربة: المستوى 5: المستوى 4 + خيارات الأسهم المكشوفة",
            level6: "لا أرغب في إضافة إمكانية تداول الخيارات لهذا الحساب",
        },

        experience: {
            welcome: "أهلًا وسهلًا",
            investment_experience: " الآن يرجى إعلامنا بتجربتك الاستثمارية وأهدافك الاستثمارية.",
            previous_investment: "الخبرة الاستثمارية السابقة",
            stocks: "الأوراق المالية",
            year: "سنة",
            average_size: "متوسط حجم",
            average_number: "متوسط عدد",
            options: "الخيارات:",
            investment_objective: "أهداف الاستثمار",
            speculative_activity: "يرجى تحديد هدف الاستثمار الأكثر أهمية بالنسبة لك. بسبب نوع الحساب والميزات التي حددتها سابقًا في عملية التطبيق، قد يتم تعطيل أول هدفين. الاستثمار في أسهم \"بيني\" على خيارات الهامش أو التداول (بخلاف الخيار المستوى 1)، على سبيل المثال، يعتبر مضاربة ويتطلب تسامحًا كبيرًا في المخاطر. إذا كان هدف الاستثمار الخاص بك أقل خطورة وما زلت ترغب في اتخاذ هذه الخيارات، فيجب عليك العودة وإلغاء تحديد هذه الميزات.",
            objective: "موضوعي",
            risk_tolerance: "أهداف الاستثمار. دخل. تحمل المخاطر: معتدل. الأفق الزمني: أقل من 5 سنوات (يشير الهدف الاستثماري للدخل إلى أنك تسعى إلى تحقيق دخل من الاستثمارات وتهتم بالاستثمارات التي أظهرت تاريخيًا مخاطر أقل لخسارة القيمة الأصلية مقارنةً بالأهداف الأخرى. بعض الأمثلة على الاستثمارات النموذجية (قد تتضمن منتجات دخل ثابت عالية الجودة وقصيرة الأجل وخيارات الاتصال المغطاة. أنت وحدك المسؤول عن تحديد ما إذا كان كل استثمار تقوم به متوافقًا مع أهدافك الاستثمارية وملف تعريف المخاطر الخاص بك. ولن تقوم ChoiceTrade بمراقبة ذلك نيابةً عنك.)",
            capital_appreciation: "الهدف الاستثماري: زيادة رأس المال. تحمل المخاطر: المضاربة. الأفق الزمني: أقل من 5 سنوات (يشير الهدف الاستثماري لتقدير رأس المال إلى أنك تسعى إلى زيادة القيمة الرئيسية لاستثماراتك بمرور الوقت وأنك على استعداد للاستثمار في الأوراق المالية التي أظهرت تاريخيًا درجة أعلى من المتوسط من مخاطر فقدان القيمة الأصلية لتحقيق هذا الهدف. بعض الأمثلة من الاستثمارات النموذجية قد تشمل الأسهم العادية، ومنتجات الدخل الثابت ذات الجودة المنخفضة، وصناديق الاستثمار المشتركة، وصناديق المؤشرات. أنت وحدك المسؤول عن تحديد ما إذا كان كل استثمار تقوم به يتوافق مع أهدافك الاستثمارية وملف المخاطر الخاص بك. لن تقوم ChoiceTrade بمراقبة هذا لك. إذا اخترت هذا الهدف، فلن تتمكن من شراء أسهم أو خيارات OTC (بيني).)",
            time_horizon: "هدف الاستثمار: المضاربة. تحمل المخاطر: المضاربة. أفق زمني. أقل من 5 سنوات (يشير الهدف الاستثماري للمضاربة إلى أنك تسعى إلى زيادة كبيرة في القيمة الرئيسية لاستثماراتك وأنك على استعداد لقبول درجة مقابلة أكبر من المخاطر من خلال الاستثمار في الأوراق المالية التي أظهرت تاريخياً درجة عالية من مخاطر خسارة الأصول) القيمة الأساسية لتحقيق هذا الهدف، تتجاوز في بعض الأحيان استثمارك الأساسي. قد تسعى إلى الاستفادة من فرص التداول قصيرة الأجل، والتي قد تنطوي على إنشاء وتصفية المراكز بسرعة. قد تتضمن بعض الأمثلة على الاستثمارات النموذجية انخفاض الجودة، والاستثمارات طويلة الأجل منتجات الدخل الثابت، والاكتتابات العامة الأولية، والأسهم العادية المتقلبة أو المنخفضة السعر، وشراء أو بيع خيارات البيع أو الشراء، والفروقات، والنطاقات و/أو المجموعات على الأسهم أو المؤشرات، واستخدام استراتيجيات التداول قصيرة الأجل أو اليومية. نحن وحدنا المسؤولون عن تحديد ما إذا كان كل استثمار تقوم به يتوافق مع أهدافك الاستثمارية وملف المخاطر الخاص بك، ولن تقوم ChoiceTrade بمراقبة ذلك نيابةً عنك. إذا كنت ترغب في تداول الأسهم أو الخيارات الصغيرة (بخلاف المكالمات المغطاة)، أو إذا كنت ترغب في التداول اليومي (أي نوع من الأوراق المالية)، فهذا هو الهدف الوحيد الذي سنقبله قبل السماح لحسابك بالتداول في هذه الأوراق المالية المضاربة.)",
            document_delivery: "تسليم الوثائق",
            additional_fees: "أوافق على استلام المستندات التالية عبر البريد الإلكتروني بدلاً من البريد العادي (هناك رسوم إضافية لاستلام المستندات الورقية عبر البريد)",
            trade_conf_email: "تأكيدات التجارة عن طريق البريد الإلكتروني.",
            account_statement_email: "كشوفات الحساب عن طريق البريد الإلكتروني.",
            proxy_statement_email: "بيانات الوكيل عن طريق البريد الإلكتروني.",
            prospectuses_email: "النشرات عن طريق البريد الإلكتروني.",
            tax_document_email: "المستندات الضريبية عن طريق البريد الإلكتروني.",
        },

        conditions: {
            thanks: "شكرًا",
            terms_condition: "نحتاج الآن منك مراجعة بعض الشروط والأحكام الخاصة بكل اتفاقية أدناه والموافقة عليها. (يرجى فتح كل علامة تبويب ووضع علامة في المربع)",
            financial_information: "الإفصاحات",
            customer_agreement: "اتفاقية العميل",
            conditions_governing: "أقر بأنني قرأت وفهمت ووافقت على الشروط والأحكام التي تحكم هذا الحساب على النحو الوارد في",
            conditions_governing2: " أوافق على الالتزام بهذه الشروط والأحكام السارية حاليًا والتي قد يتم تعديلها من وقت لآخر دون إشعار مسبق لي. أتعهد بأن جميع المعلومات التي أدخلتها في طلبي صحيحة على حد علمي واعتقادي. إذا كان هناك تغيير في المستقبل، فإنني أوافق على إخطار ChoiceTrade كتابيًا على الفور.",
            arbitration_agreement: "أدرك أن هذا الحساب يخضع لاتفاقية التحكيم المنصوص عليها في الفقرتين 18 و19 من اتفاقية العميل. أقر باستلام اتفاقية التحكيم واتفاقية حساب العميل التي تحكم حسابي. أقر بأنني قرأت وفهمت بيان الإفصاح عن مخاطر التداول النشط، وبيان الإفصاح عن الهامش، وبيان خصوصية ChoiceTrade. أدرك وأقر بأن (1) طلب الحساب هذا لم يتم تقديمه بناءً على أي التماس، (2) ChoiceTrade ليست تابعة أو وكيلة لشركة المقاصة التابعة لها، و (3) لا يوجد هنا عرض أو التماس لأي ضمان، منتج أو خدمة في أي ولاية قضائية حيث يكون عرضها أو بيعها مخالفًا للقانون أو اللوائح المحلية. أقر بأن ChoiceTrade لا تقدم نصيحة استثمارية أو ضريبية أو قانونية أو محاسبية فيما يتعلق بالقيمة المحتملة أو مدى ملاءمة استراتيجية أمنية أو استثمارية معينة.",
            fee_acknowledgement: "إقرار الرسوم",
            service_fee: "تتضمن بعض المنصات رسوم خدمة شهرية. أقر وأوافق على دفع رسوم الخدمة عن طريق السماح لـ ChoiceTrade بالخصم من حسابي. أقر بأنه قد يتم دفع رسوم الباحث وفقًا للاتفاقية.",
            margin_agreement1: "اتفاقية الهامش (فيلوكس)",
            margin_agreement: "اتفاقية الهامش",
            margin_agreement2: "اتفاقية الهامش",
            margin_terms: "أوافق على جميع شروط ملحق الهامش. أقر بأن الأوراق المالية لحساب الهامش الخاص بي قد يتم استعارتها بواسطتي أو إقراضها للآخرين.",
            margin_risk: "بيان الإفصاح عن مخاطر الهامش",
            options_agreement: "اتفاقية الخيارات",
            any_material_change: "أوافق على تقديم المشورة لـ ChoiceTRAD بشأن أي تغيير جوهري في وضعي المالي و/أو أهدافي الاستثمارية. أوافق على جميع شروط ملحق الخيارات. أقر بأنني قرأت وثيقة الإفصاح على الرابط التالي، \"خصائص ومخاطر الخيارات الموحدة\" وأنا على علم بالمخاطر الخاصة الكامنة في تداول الخيارات.",
            option_disclosures: "إفصاحات الخيار",
            options_supplement: "ملحق الخيارات",
            taxpayer_id_number: "شهادة رقم هوية دافع الضرائب (بديل W-9) (يُرجى تخطي هذا القسم إذا لم تكن شخصًا أمريكيًا للأغراض الضريبية)",
            notified_irs: "حدد هذا المربع إذا تم إخطارك من قبل مصلحة الضرائب الأمريكية بأنك معفى من الاستقطاع الاحتياطي. (يُرجى تخطي هذا القسم إذا كان لا ينطبق عليك أو إذا لم تكن شخصًا أمريكيًا للأغراض الضريبية)",
            penalty_of_perjury: "تحت عقوبة الحنث باليمين، أتعهد بما يلي:",
            number_1: "1. الرقم الموضح في هذا الطلب هو رقم هوية دافع الضرائب الصحيح (أو أنا في انتظار إصدار رقم لي) و",
            number_2: "2. أنا لا أخضع للاقتطاع الضريبي الاحتياطي لأنني (أ) معفى من الاقتطاع الضريبي الاحتياطي، أو (ب) لم يتم إخطاري من قبل دائرة الإيرادات الداخلية (IRS) بأنني أخضع للاقتطاع الضريبي الاحتياطي نتيجة لفشل ما للإبلاغ عن جميع الفوائد أو أرباح الأسهم، أو (ج) أخطرتني مصلحة الضرائب الأمريكية بأنني لم أعد خاضعًا للاقتطاع الضريبي الاحتياطي (لا ينطبق على المعاملات العقارية، أو فوائد الرهن العقاري المدفوعة، أو الاستحواذ على الممتلكات المضمونة أو التخلي عنها، أو المساهمات المقدمة إلى فرد حساب التقاعد (IRA)، والمدفوعات بخلاف الفوائد وأرباح الأسهم.)",
            number_3: "3. أنا شخص أمريكي (بما في ذلك أجنبي مقيم في الولايات المتحدة). تعليمات الشهادة - يجب عليك شطب البند 2 أعلاه إذا تم إخطارك من قبل مصلحة الضرائب الأمريكية، بأنك تخضع حاليًا للاستقطاع الاحتياطي لأنك فشلت في الإبلاغ عن جميع الفوائد والأرباح في إقرارك الضريبي.)",
            clearing_authorization: "ترخيص شركة المقاصة",
            client_auth_condition: "توفر شركة المقاصة لدينا إمكانية الوصول لعرض التقارير المختلفة. يرجى تحديد هذا المربع للسماح لهم بتقديم هذه الخدمة لك.",
            agreew8_heading: "نموذج شهادة W8-BEN للحالة الضريبية",
            agreew8_text: "وأنا أتفق مع الشهادة المذكورة أعلاه. أقر بأنه يجب علي تقديم الإعلان الوارد في بيان الحنث باليمين الخاص بنموذج IRS W8-BEN وأنني أقوم بهذا الإعلان من خلال توقيعي أدناه. أوافق بموجب هذا على إرسال نموذج W8-BEN الخاص بي إلكترونيًا والسماح لشركة ChoiceTrade بمشاركته مع شركة المقاصة التابعة لها.",
            w8_form: "نموذج W8",
            finder_heading: "اتفاقية المكتشف الأجنبي",
            finder_text1: "يقر العميل الموقع أدناه ويوافق على كل مما يلي:",
            finder_text2: "أنا/نحن لسنا مواطنين أو مقيمين في الولايات المتحدة. في حالة التقديم نيابةً عن كيان، فإن الكيان ليس كيانًا أمريكيًا، ولا يقع مقره في الولايات المتحدة.",
            finder_text3: "لم تطلب مني ChoiceTrade فتح حساب مع ChoiceTrade. لكي أتمكن من ممارسة الأعمال التجارية في ChoiceTrade، ليس من الضروري أن تكون ChoiceTrade مسجلة في ولايتي القضائية",
            finder_text4: "يخضع حسابي لترتيبات التعويض التي بموجبها ستدفع ChoiceTrade للباحثين غير الأمريكيين",
            finder_text5: "(\"المكتشفون\") التعويضات المتعلقة بالمعاملة. جدول العمولات الخاص بي هو الجدول المعتاد لـ ChoiceTrade ما لم يتم ذكره أدناه أيضًا. إن Finders ليسوا وسطاء أو موظفين أو وكلاء لشركة ChoiceTrade، ولن أتعامل/نتعامل مع Finders فيما يتعلق بعملي/أعمالنا مع ChoiceTrade. بخلاف علاقات المكتشف، ليس لدى ChoiceTrade أي علاقة مع Finders. أنا/سنتعامل مباشرة مع ChoiceTrade فيما يتعلق بجميع جوانب حساب ChoiceTrade الخاص بي/حسابنا.",
            finder_text6: "من خلال التوقيع على هذا الطلب، أنا/نحن نفهم ونقر ونوافق على ما سبق اعتبارًا من تاريخ سريان الطلب.",
            privacy: "خصوصية",
            trading_header: "اتفاقية التداول",
            trading_text1: "لقد قرات ووافقت على ال",
            trading_text2: "اتفاقية ترخيص التداول",
            trading_text3: "من خلال ملء هذا الطلب والتوقيع عليه.",
            foreignfinder: "سوف تدفع شركة ChoiceTrade رسومًا لغير الولايات المتحدة. Finder، Red Information Technology Ltd. تعويضًا متعلقًا بالمعاملة يبلغ نصف الربح من حصة ChoiceTrade من العمولات وفوائد الهامش التي أدفعها. وهذه النسبة قابلة للتغيير."
        },

        review: {
            next: "التالي،",
            review_info: ".يرجى مراجعة المعلومات الخاصة بك",
            click_here: "انقر هنا",
            print_page: ".لطباعة الصفحة",
            review_app: "مراجعة التطبيق",
            registration: "التسجيل:",
            edit: "تحرير",
            citizen_status: "حالة المواطنة:",
            account_type: "نوع الحساب:",
            personal_info: "المعلومات الشخصية:",
            title: "اللقب:",
            first_name: "الاسم الأول:",
            last_name: "الاسم الأخير:",
            date_of_birth: "تاريخ الولادة:",
            ssn: "الضمان الاجتماعي:",
            marital_status: "الحالة الإجتماعية:",
            permanent_address: "العنوان الدائم:",
            select_state: "اختر حالة",
            different_address: "عنواني البريدي مختلف",
            address2: "العنوان 2:",
            city: "المدينة:",
            country: "دولة:",
            zip_code: "الرمز البريدي / الرمز البريدي:",
            employment: "توظيف:",
            employment_status: "حالة التوظيف:",
            contact_info: "معلومات الاتصال:",
            phone: "الوقت المتاح للإتصال:",
            email: "بريد إلكتروني:",
            financial_info: "المعلومات المالية:",
            source_of_income: "المصدر الأساسي للدخل:",
            annual_income: "الدخل السنوي:",
            liquid_assets: "أصول سائلة:",
            net_worth: "رأس المال:",
            account_privileges: "امتيازات الحساب:",
            investment_account_type: "نوع الحساب الاستثماري:",
            investment: "نوع الحساب الاستثماري:",
            mailing_address: "عنوان بريدي:",
            perm_address: "نفس العنوان الدائم:",
            mailing_address2: "العنوان 2:",
            mailing_city: "المدينة:",
            mailing_state: "ولاية:",
            mailing_country: "دولة:",
            mailing_zip_code: "الرمز البريدي / الرمز البريدي:",
            previous_investment: "الخبرة الاستثمارية السابقة:",
            stocks: "مخازن:",
            year: "سنين:",
            average_size: "حجم متوسط:",
            average_number: "متوسط عدد المعاملات/السنة:",
            options: "خيارات:",
            investment_objective: "أهداف الاستثمار:",
            investment_experience_text: "هدف الاستثمار: المضاربة. تحمل المخاطر: المضاربة. أفق زمني. أقل من 5 سنوات",
            specific_option_level: "هدف الخيار المحدد ومستوى تداول الخيارات المطلوبة:"
        },

        signature: {
            sign_and_submit: "تسجيل وإرسال",
            signature: "إمضاء:",
            primary_account: "مالك الحساب الأساسي",
            signature_line: "يرجى التوقيع على الوثيقة عن طريق كتابة اسمك الأول واسم العائلة على سطر التوقيع.",
            arbitration_agreement: "أدرك أن هذا الحساب يخضع لاتفاقية التحكيم المنصوص عليها في الفقرتين 18 و19 من اتفاقية العميل. أقر باستلام اتفاقية التحكيم واتفاقية حساب العميل التي تحكم حسابي.",
            terms_and_conditions: "أقر بأنني قرأت وفهمت ووافقت على الشروط والأحكام التي تحكم هذا الحساب على النحو الوارد في اتفاقية العميل. أوافق على الالتزام بهذه الشروط والأحكام السارية حاليًا والتي قد يتم تعديلها من وقت لآخر دون إشعار مسبق لي. أتعهد بأن جميع المعلومات التي أدخلتها في طلبي صحيحة على حد علمي واعتقادي. إذا كان هناك تغيير في المستقبل، فإنني أوافق على إخطار ChoiceTrade كتابيًا على الفور. أقر بأنني قرأت وفهمت",
            risk_disclosure_statement: "بيان الإفصاح عن مخاطر التداول النشط، وبيان الإفصاح عن الهامش، وبيان خصوصية ChoiceTrade.",
            service_fee: "أدرك وأقر بأن (1) طلب الحساب هذا لم يتم تقديمه بناءً على أي التماس، (2) ChoiceTrade ليست تابعة أو وكيلة لشركة المقاصة التابعة لها، و (3) لا يوجد هنا عرض أو التماس لأي ضمان، المنتج أو الخدمة في أي ولاية قضائية حيث يكون عرضها أو بيعها مخالفًا للقانون أو اللوائح المحلية. أقر بأن ChoiceTrade لا تقدم مشورة استثمارية أو ضريبية أو قانونية أو محاسبية فيما يتعلق بالقيمة المحتملة أو مدى ملاءمة استراتيجية أمنية أو استثمارية معينة. تتضمن بعض المنصات رسوم خدمة شهرية.",
        },

        welcome_to: {
            welcome_to: "مرحبًا بك في ChoiceTrade",
            upload: "رفع",
            account_funding: "تمويل الحساب",
            funding_instruction: "بمجرد الموافقة على حسابك والحصول على رقم حساب، يمكنك تمويله على الفور.",
            click_here: "الرجاء الضغط هنا للحصول على تعليمات التمويل.",
            attention: "تنبيه: هناك حاجة إلى نماذج إضافية! يرجى اتباع التعليمات التالية. من أجل البدء في عملية مراجعة طلبك، يرجى تقديم المستندات التالية. يمكنك تحميل المستندات إلينا بشكل آمن باستخدام وظيفة UPLOAD أدناه. (إذا لم تتمكن من تحميل المستندات، فيمكنك إرسالها بالبريد الإلكتروني إلىservice@choicetrade.com بشكل منفصل وسنقوم بإرفاقها بطلبك. إذا أرسلت عبر البريد الإلكتروني، فتأكد من الإرسال من عنوان البريد الإلكتروني الذي قدمته في حسابك طلب..",
            application: "المتقدمون في الولايات المتحدة: يرجى تقديم نسخة من رخصة القيادة الحالية الخاصة بك. (لن يتم قبول التراخيص منتهية الصلاحية). يرجى إرسال الصفحة الأولى من أحدث كشف حساب مصرفي لديك والذي ستستخدمه لتمويل حسابك. إذا كنت ستستخدم أكثر من بنك واحد مع حسابك، فيرجى تقديم هذه المعلومات لجميع البنوك. يرجى ملاحظة ما يلي: يجب أن يتطابق الاسم والعنوان الموجودان في كشف حسابك البنكي تمامًا مع المعلومات التي قدمت طلبًا بها. إذا قمت بإرسال أموال من حساب لا يتطابق مع المعلومات الموجودة لدينا في ملفك، فسيتم إرجاع أموالك وستتحمل رسومًا مصرفية ورسومًا أخرى.",
            non_resident: "غير المقيمين: يرجى تقديم نسخة من جواز سفرك الحالي. فقط إذا قمت بذلك، يرجى إرسال الصفحة الأولى من أحدث كشف حساب مصرفي لديك والذي ستستخدمه لتمويل حسابك. إذا كنت ستستخدم أكثر من بنك واحد مع حسابك، فيرجى تقديم هذه المعلومات لجميع البنوك. يرجى ملاحظة ما يلي: يجب أن يتطابق الاسم والعنوان الموجودان في كشف حسابك البنكي تمامًا مع المعلومات التي قدمت طلبًا بها. ستحتاج إلى إرسال إثبات للعنوان مثل فاتورة مرافق لأحد العناوين. إذا قمت بإرسال أموال من حساب لا يتطابق مع المعلومات الموجودة لدينا في ملفك، فسيتم إرجاع أموالك وستتحمل رسومًا مصرفية ورسومًا أخرى.",
            complete_app: "تهانينا! طلبك مكتمل. في الوقت الحالي، إليك رقم تأكيد الطلب كمرجع:",
            complete_app_number: "(هذا ليس رقم حسابك).",
            complete_app_continue1: "إذا لم تكن قد قمت بذلك بالفعل، فيرجى إرسال نسخة من بطاقة هويتك الحالية الصادرة عن الحكومة مثل رخصة القيادة أو جواز السفر أو بطاقة الهوية الوطنية - يجب أن تحتوي هذه الوثيقة على اسمك وصورتك وتاريخ ميلادك. بمجرد إرساله، ستقوم ChoiceTrade بمراجعة طلبك. عند الموافقة، سيتم إصدار رقم حساب لك ومعلومات تسجيل الدخول وسيتم تزويدك بتعليمات التمويل عبر البريد الإلكتروني. من فضلك لا تبدأ التمويل قبل أن يكون لديك رقم الحساب.",
            complete_app_continue2: "يمكنك النقر فوق الزر \"التقاط الصورة\" أدناه لالتقاط صورة واضحة لمستندك وإرسالها باستخدام كاميرا جهازك أو يمكنك تحميل الملف إلينا إذا كان لديك بالفعل محفوظًا على جهازك. (يمكنك أيضًا إرسالها بالبريد الإلكتروني إلى ",
            mail_to: "service@choicetrade.com",
            complete_app_continue3: "بشكل منفصل وسنقوم بإرفاقه بطلبك. إذا كنت ترسل عبر البريد الإلكتروني، فتأكد من الإرسال من عنوان البريد الإلكتروني الذي قدمته في طلب حسابك.)",
            capture_image: "التقاط الصورة",
            doc_verification: "التحقق من الوثيقة",
            picture_id: "نحن بحاجة إلى صورة من بطاقة الهوية الخاصة بك",
            confirm_doc: "يرجى وضع المستند الخاص بك بحيث يملأ إطار شاشة الكاميرا.",
            retake_photo: "إعادة التقاط الصورة",
            photo_text: "هل الصورة واضحة وليست مقطوعة؟"
        },

        welcome_back: {
            welcome_back: "مرحبًا بعودتك!",
            click_below: "انقر أدناه لاستئناف تطبيق قيد التقدم بالفعل.",
            app_in_progress: "لديك طلب (طلبات) مكتملة أو قيد التقدم. انقر على أي واحد للمتابعة.",
            individual: "فردي",
            second_app: "تقديم الطلب الثاني",
            delete: "يمسح",
            account: "حساب",
            started: "بدأ في",
            completed: "لقد أكملت",
            completed_of: "من 7 خطوات"
        },

        logout_modal: {
            logout_text: "إذا انتهيت من التطبيق، فانقر فوق \"موافق\"، للبقاء في الصفحة، انقر فوق \"إلغاء الأمر\".",
            ok: "نعم",
            cancel: "يلغي"
        },

        login: {
            login: "تسجيل الدخول",
            enter_email: "أدخل البريد الإلكتروني",
            enter_password: "أدخل كلمة المرور",
            cancel: "يلغي",
            forget_password: "نسيت كلمة السر؟",
            forgot_password: "هل نسيت كلمة السر",
            retrieve_password: "لاسترداد كلمتك، أدخل عنوان بريدك الإلكتروني أدناه",
            send_message: "لقد أرسلنا رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني",
            acc_not_found: "الحساب غير موجود!",
            user_not_found: "لم يتم العثور على المستخدم!",
            email: "بريد إلكتروني",
            new_password: "كلمة المرور الجديدة",
            confirm_new_password: "تأكيد كلمة المرور الجديدة",
        },

        modals: {
            ind_modal: {
                joint1: "مالكان مشتركان لعقار تؤول ملكيته بمجرّد وفاة أحدهما إلى الطرف الآخر",
                joint2: "المستأجرون المشتركون",
                joint3: "الاشتراك مع المستأجرين بالكامل",
                joint4: "ملكية الزوجين المشتركة",
            },

            ira_modal: {
                ira: "الآن يرجى تزويدنا بالمعلومات حول المستفيد من حساب IRA الخاص بك.",
                close: "يغلق",
                ira1: "الجيش الجمهوري الايرلندي التقليدي",
                ira2: "روث إيرا",
                ira3: "إيرا بسيط",
                ira4: "كوفرديل إيرا",
                ira5: "سبتمبر الجيش الجمهوري الايرلندي",
                ira6: "التمديد إيرا"
            },

            special_modal: {
                corporate: "شركة",
                non_profit: "غير ربحية",
                invest_club: "نادي الاستثمار",
                limited_company: "شركة محدودة المسؤولية",
                partnership: "الشراكة",
                partnership_corp: "شراكة",
                trust: "تأمين",
                c_corporation: "شركة ج",
                s_corporation: "شركة S",
                trust_ssn: "هل يستخدم المؤتمن رقم الضمان الاجتماعي الخاص بالوصي؟",
                trust_id: " هل لدى الصندوق رقم معرف ضريبي خاص به؟",
                close: "يغلق",
                member: "عضو"
            }
        },

        specialty: {
            trust_company_name: "الثقة أو اسم الشركة أو المنظمة",
            country_of: "بلد التأسيس/المنظمة",
            for_accounts: "بالنسبة لحسابات الكيانات وIRAS، نحتاج إلى معلومات إضافية عن الأمناء أو الموقعين المعتمدين أو المستفيدين.",
            middle_name: "الاسم الأوسط",
            entity_role: "دور الكيان",
            president: "رئيس",
            treasurer: "أمين صندوق",
            vice_president: "نائب الرئيس",
            secretary: "سكرتير",
            add_signer: "أحتاج إلى إضافة موقع معتمد آخر"
        },

        custodial: {
            thanks: "شكرًا",
            provide_info: "الآن يرجى تزويدنا بالمعلومات حول القاصر الذي تقوم بإعداد هذا الحساب له."
        },

        joint: {
            thanks: "شكرًا لك",
            joint_info: "المعلومات الشخصية للمالك المشترك",
            provide_joint_info: "بعد ذلك، يرجى تقديم معلومات لكل مالك مشترك في الحساب.",
            joint_account_spouse: "هل صاحب الحساب المشترك هو زوج صاحب الحساب الأساسي؟",
            joint_primary_address: "هل العنوان الأساسي هو نفسه عنوان مالك الحساب؟",
            yes: "نعم",
            no: "لا",
            evening_phone: "هاتف المساء",
            are_you_member: "هل أنت أو أحد أفراد أسرتك منتسب أو موظف لدى وسيط / مستشار استثماري لشركة تأمين تاجر / وسيط مسجل يمارس الأعمال التجارية في الولايات المتحدة أو أي بورصة أمريكية أو منظمة ذاتية التنظيم بما في ذلك SEC FINRA NFA أو CFTC؟",
            indicate: "الرجاء تحديد النسبة المئوية للملكية لكل فرد أدناه"
        },

        tooltip: {
            country_tooltip: "إذا لم يكن بلدك مدرجًا، فلن نتمكن من قبول طلبك. يرجى مراسلتنا عبر البريد الإلكتروني علىservice@choicetrade.com إذا كانت لديك أسئلة. لا يُسمح للمواطنين الكنديين الذين يعيشون في كندا بفتح حساب مع وسيط أمريكي، وفقًا للقانون الكندي.",
            state_tooltip: "تم تسجيل ChoiceTrade في الولايات الأمريكية الخمسين والعاصمة ولكن ليس في الأراضي الأمريكية. نأسف لأننا لا نستطيع قبول المتقدمين من بورتوريكو وغوام وجزر فيرجن الأمريكية والأقاليم الأمريكية الأخرى.",
            country_tooltip_message: "لماذا لم يتم إدراج بلدي؟",
            state_tooltip_message: "لماذا لم يتم إدراج ولايتي؟",
            cash_margin_tooltip: "حساب الهامش هو الحساب الذي يتمتع بامتيازات القرض. في حساب الهامش، سوف تحصل على عائدات المبيعات على الفور مقابل عملية شراء جديدة؛ في حساب نقدي لا يجوز لك. حساب الهامش هو نوع الحساب الوحيد الذي يمكنك من خلاله بيع الأسهم. يرجى قراءة الكشف عن الهامش لدينا. نظرًا لأن الهامش هو نوع حساب أكثر خطورة من النقد، إذا كان هدفك الاستثماري يشير إلى الأمان، فقد لا تتم الموافقة على طلب الهامش الخاص بك ويجب عليك التفكير في التقدم بطلب للحصول على حساب نقدي. يجب عليك تمويل حساب الهامش بما لا يقل عن 2000 دولار والحفاظ عليه عند هذا المستوى أو أعلى.",
            cash_tooltip: "الحساب النقدي هو أبسط امتياز حسابي. بحكم التعريف، أي حساب لا يتمتع بامتيازات الهامش هو حساب نقدي. في الحساب النقدي، إذا اشتريت سهمًا في يوم معين وقمت ببيعه قبل تسوية الشراء (تاريخ التسوية هو يوم عمل واحد من تاريخ الشراء)، فلن تكون العائدات من البيع متاحة لشراء جديد حتى يوم عمل واحد بعد البيع. لذلك، قد تقرر، لهذا السبب وحده، أن حساب الهامش هو الحساب المناسب لك."
        },

        about: {
            about_us: "معلومات عنا",
            about_us1: "نقدم لكم ChoiceTrade، الوجهة الأولى للمتداولين النشطين والمستثمرين الموجهين ذاتيًا وعشاق سوق الأسهم على حدٍ سواء. تأسست ChoiceTrade مع الالتزام بتمكين المستثمرين من جميع المستويات، وتقدم منصة تداول سلسة وبديهية على شبكة الإنترنت مصممة لتبسيط تجربة التداول.",
            about_us2: "في ChoiceTrade، ندرك أن التعامل مع تعقيدات سوق الأوراق المالية قد يكون أمرًا شاقًا. ولهذا السبب قمنا بتصميم منصة تعطي الأولوية للوضوح وسهولة الاستخدام، مما يزيل الفوضى والتعقيدات غير الضرورية. سواء كنت متداولًا متمرسًا أو مجرد غوص في عالم الاستثمار، توفر ChoiceTrade الأدوات والموارد التي تحتاجها لاتخاذ قرارات مستنيرة بثقة.",
            about_us3: "مهمتنا بسيطة. لتزويد عملائنا \"بخيار\" حقيقي في رحلة التداول الخاصة بهم. مع ChoiceTrade، يمكنك أن تثق في أن المزايا والراحة والخدمة تتجاوز بكثير العمولات التي ستدفعها، بغض النظر عن مستوى تطور التداول الخاص بك.",
            about_us4: "انضم إلينا في ChoiceTrade واختبر الفرق بنفسك. تحكم في مستقبلك المالي من خلال منصة تضع احتياجاتك في المقام الأول. مرحبًا بك في عصر جديد من التميز التجاري. مرحبًا بك في ChoiceTrade.",
        }
    },
}